// extracted by mini-css-extract-plugin
export var alignBaseline = "_x-9";
export var alignCenter = "_x-5";
export var alignFlexEnd = "_x-7";
export var alignFlexStart = "_x-6";
export var alignSelfBaseline = "_x-e";
export var alignSelfCenter = "_x-a";
export var alignSelfFlexEnd = "_x-c";
export var alignSelfFlexStart = "_x-b";
export var alignSelfStretch = "_x-d";
export var alignStretch = "_x-8";
export var column = "_x-2";
export var columnReverse = "_x-4";
export var flex = "_x-0";
export var justifyCenter = "_x-f";
export var justifyFlexEnd = "_x-h";
export var justifyFlexStart = "_x-g";
export var justifySpaceAround = "_x-j";
export var justifySpaceBetween = "_x-i";
export var justifySpaceEvenly = "_x-k";
export var row = "_x-1";
export var rowReverse = "_x-3";
export var wrapNowrap = "_x-m";
export var wrapWrap = "_x-l";
export var wrapWrapReverse = "_x-n";